import { Component, Input, OnInit } from '@angular/core';
import { DataColumn } from '../../../../models';
import { MatDialog } from '@angular/material/dialog';
import { HistoriqueDetailsComponent } from './historique-details/historique-details.component';
import { CandidatStatusOnMission } from '../../../../shared/utils/enums';
import { UserComponent } from '../../../../shared/user/user.component';
import { CandidaturesMissionComponent } from '../encour-component/components/candidatures-mission/candidatures-mission.component';
import { TableEnCourActionComponent } from '../encour-component/components/table-en-cour-action/table-en-cour-action.component';
import { Mission } from '../../../../models/Mission';
import { Site } from '../../../../models/Site';
import { Router } from '@angular/router';
import { MissionService } from '../../../../services/mission.service';
import { FormBuilder } from '@angular/forms';
import { EstablishmentService } from '../../../../services/establishment.service';
import { CookieService } from 'ngx-cookie-service';
import { debounceTime } from 'rxjs';
import { MissionDetailsComponent } from '../encour-component/mission-details/mission-details.component';
import moment from 'moment';
import { removeBlankAttributes } from '../../../../shared/utils/utils.functions';
import { AuthService } from '../../../../services/auth.service';
import {
  filterList,
  filterListDone,
} from '../../../../shared/utils/data/etablissments-data';
import { ReferenceTitleComponent } from '../reference-title/reference-title.component';

@Component({
  selector: 'app-historique-component',
  templateUrl: './historique-component.component.html',
  styleUrl: './historique-component.component.scss',
})
export class HistoriqueComponentComponent implements OnInit {
  // filterList = [
  //   {label : 'Terminés',value : CandidatStatusOnMission.ARCHIVED},
  //   {label : 'Confirmés',value : CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH},
  //   {label : 'Acceptés',value : CandidatStatusOnMission.ACCEPTED},
  //   {label : 'Publiés',value : CandidatStatusOnMission.NEUTRAL},
  //   {label : 'Non publiés',value : CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION},
  // ]
  component: any[] = [UserComponent];
  randomData: any[] = [];
  isLoading: boolean = false;
  // Define the custom columns array
  customColumns: DataColumn[] = [
    {
      header: 'Référence',
      fieldName: 'missionTitle',
      component: ReferenceTitleComponent,
      dataType: 'component',
      col: 'col',
    },
    { header: 'Site', fieldName: 'site', dataType: 'string',  col: 'col',},
    {
      header: 'Service d’affectation',
      fieldName: 'serviceAffectationsName',
      dataType: 'string',
      col: 'col',
    },
     { header: 'Poste', fieldName: 'typePoste', dataType: 'string',col: 'col', },
    {
      header: 'Type de contrat',
      fieldName: 'typecontat',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Dates',
      fieldName: 'duration',
      fieldNameStartDate: 'startdate',
      fieldNameEndDate: 'enddate',
      dataType: 'date',
      col: 'col',
    },
    {
      header: 'Rémunération',
      fieldName: 'compensationproposednet',
      fieldNameCurrency: 'currency',
      dataType: 'currency',
      col: 'col',
    },
    {
      header: 'Candidatures',
      fieldName: 'candidatures',
      dataType: 'component',
      component: CandidaturesMissionComponent,
      col: 'col',
    },

    {
      header: 'Statut',
      fieldName: '',
      component: TableEnCourActionComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },
  ];
  id: number;
  missionList: Mission[] = [];
  offset = 0;
  size = 10;
  totalItems = 0;
  siteList: Site[] = [];

  formFilter = this.fb.group({
    adresseId: undefined,
    endDate: [moment(new Date()).local()], //moment(new Date()).format('yyyy-MM-DD')
    missionTitle: [''],
    page: 0,
    size: 10,
    startDate: [''],
    // "Filtrer par date": keep missions whose span contains this date (startdate <= date <= enddate).
    activeOnDate: [<any>null],
    missionStatus: [[
      "PENDING",
      "VALIDATED",
      "INVALIDATED",
      "MISSION_WILL_START_SOON",
      "MISSION_ALREADY_STARTED",
      "CANCELED"
    ]],
    statusOfCandidatOnMission: [[]],
  });

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private api: MissionService,
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private auth: AuthService
  ) {
    this.id = this.auth.id??this.auth?.user?.collary_id??0
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetshMission();
    this.getSitesByEstablishment();
    this.formFilter.valueChanges.pipe(debounceTime(700)).subscribe((value) => {
      this.fetshMission();
    });
  }

  getSitesByEstablishment() {
    this.establishmentService
      .getSiteByEstablishmentId(this.id, true)
      .subscribe({
        next: (res) => {
          this.siteList = res;
        },
        error: () => {},
      });
  }

  fetshMission(): void {
    this.isLoading = true;
    const body: any = { ...this.formFilter.value };
    // Normalize the "active on date" filter to a start-of-day datetime the backend can parse.
    if (body.activeOnDate) {
      body.activeOnDate = moment(body.activeOnDate).format('YYYY-MM-DDT00:00:00');
    }
    this.api
      .getMissionsByEstablishmentId(
        removeBlankAttributes(body),
        this.id
      )
      .subscribe({
        next: (res: { content: Mission[]; totalElements: number }) => {
          this.missionList = res.content.map((mission) => {
            if (mission.typecontat == 'LIBERAL') {
              mission.typecontat = 'Intérim';
            }
            mission.site = mission?.adresseDto?.name??'';
            return mission;
          });
          this.totalItems = res.totalElements;
        },
        error: () => {},
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleRowClick = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.fetshMission();
      }
    });
  };
  pagination(event: any) {
    this.offset = event.pageIndex * this.size;
    this.formFilter.get('page')?.patchValue(event.pageIndex);
    this.fetshMission();
  }

  toggleSelectSite(event: any, site: Site) {
    if (event) {
      // @ts-ignore
      this.formFilter.get('adresseId')?.patchValue(site.id);
    } else {
      this.formFilter.get('adresseId')?.patchValue('');
    }
  }

  get addressId(): any {
    return this.formFilter.get('adresseId')?.value;
  }

  protected readonly filterListDone = filterListDone;
}
